export default "__VITE_ASSET__917a6f99__$_?react__"